import React from 'react';
import {OptionWrapper, OptionsContainer} from './styles';

function MultipleOptionsViewer({options, selected, onClickOption, disabled, testIdPrefix, disabledOptionsIds}) {
  return (
    <OptionsContainer>
      {options.map(
        option =>
          !disabledOptionsIds?.find(id => id === option.id) && (
            <OptionWrapper
              key={option.id}
              disabled={disabled}
              selected={selected === option.id}
              onClick={() => onClickOption?.(option.id)}
              data-cy={`${testIdPrefix}-${option.option}`}
            >
              {option.option}
            </OptionWrapper>
          )
      )}
    </OptionsContainer>
  );
}

export default MultipleOptionsViewer;
